import type { TimelineRecord } from '@/features/timeline/model/timeline-record';
import type { TimelineRepository } from '@/features/timeline/application/ports/timeline-repository';
import { appAnalytics } from '@/shared/analytics';

export class TimelineCatalogUseCases {
  constructor(
    private readonly repository: TimelineRepository,
  ) {}

  async findById(id: string): Promise<TimelineRecord | null> {
    return this.repository.findById(id);
  }

  async createTimeline(): Promise<TimelineRecord> {
    const record = await this.repository.create();

    const sections = record.data.pages[0].sections;
    appAnalytics.track('timeline_created', {
      timeline_id: record.id,
      creation_method: 'manual',
      section_count: sections.length,
      item_count: sections.reduce((sum, s) => sum + s.items.length, 0),
    });

    return record;
  }
}
